<template>
  <DeepIcon v-if="deepAppIconLogoId" :name="deepAppIconLogoId" />
  <NodeIcon v-else type="folder" />
</template>

<script setup lang="ts">
import { DeepIcon } from '@deepcloud/deep-ui-lib'
import NodeIcon from '@/components/node/NodeIcon.vue'
import type { GenericFolder } from '@deepcloud/api-deep-box'

const props = defineProps({
  genericFolder: {
    type: Object as PropType<GenericFolder>,
    default: undefined,
  },
})

const deepAppIconLogoId = computed(() => {
  switch (props.genericFolder?.id) {
    case 'deepmail':
      return 'deep-mail'
    case 'deepsign':
      return 'deep-sign'
    default:
      return undefined
  }
})
</script>
